/*
 * Copyright (C) 2025 Hendrik. All Rights Reserved.
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './subjects.css';

export default function Subjects() {
    const [subjects, setSubjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const loadDashboard = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/fetch_dashboard.php`);
                setSubjects(response.data.subjects || []);
            } catch (error) {
                setSubjects([]);
            } finally {
                setLoading(false);
            }
        };
        loadDashboard();
    }, []);

    // Group subjects by grade level
    const groupedByGrade = subjects.reduce((acc, subject) => {
        const grade = subject.grade || 'Other';
        if (!acc[grade]) {
            acc[grade] = [];
        }
        acc[grade].push(subject);
        return acc;
    }, {});

    // Sort grades numerically
    const sortedGrades = Object.keys(groupedByGrade).sort((a, b) => {
        if (a === 'Other') return 1;
        if (b === 'Other') return -1;
        return parseInt(a) - parseInt(b);
    });

    const handleSubjectClick = (subjectId) => {
        navigate(`/subjects/${subjectId}`);
    };

    if (loading) {
        return <div className="subjects-wrapper loading">Loading subjects...</div>;
    }

    return (
        <div className='subjects-wrapper'>
            <header className="subjects-header">
                <h1>Subjects Overview</h1>
                <p>Manage classes, marks, and student performance per grade.</p>
            </header>

            {sortedGrades.length > 0 ? (
                sortedGrades.map((grade) => (
                    <div key={`grade-${grade}`} className="grade-section">
                        <div className="grade-title-row">
                            <h2 className="grade-title">
                                Grade {grade}
                            </h2>
                            <span className="class-count-badge">
                                {groupedByGrade[grade].length} {groupedByGrade[grade].length === 1 ? 'Class' : 'Classes'}
                            </span>
                        </div>

                        <div className="subjects-grid">
                            {groupedByGrade[grade].map((subject) => (
                                <div
                                    key={subject.subject_id}
                                    className="subject-card"
                                    onClick={() => handleSubjectClick(subject.subject_id)}
                                >
                                    <div className="card-header">
                                        <h3>{subject.name}</h3>
                                        {subject.class_name && (
                                            <span className="class-badge">
                                                {subject.class_name}
                                            </span>
                                        )}
                                    </div>

                                    <div className="card-stats">
                                        <div className="stat-item">
                                            <span className="stat-label">Students</span>
                                            <span className="stat-value">{subject.student_count || 0}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))
            ) : (
                <div className="empty-state">
                    <p>No subjects found. Please contact the administrator.</p>
                </div>
            )}
        </div>
    );
}